import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import ExclamationSvg from '../../../assets/icons/app/exclamation.svg?raw';

export const ExclamationIcon = (props) => <CustomSVG svg={ExclamationSvg} preserveColors appIconSmall {...props} />;
